<template>
    <div class="modal-notify modal-content">
        <button v-if="!action" @click="$emit('close')" type="button" data-dismiss="modal" aria-label="Close" class="close"
                style="width: 30px; height: 30px; border-radius: 30px; font-size: 30px; background: gray;"><span
                aria-hidden="true">×</span></button>
        <h2 class="modal-title title-coupons lg-cond text-center pt-10 pb-10" v-if="!action">
            {{ title }}
        </h2>
        <div class="free-menu-description section-content--free-menu t13 text-black text-center">
            {{ message }}
        </div>
        <button type="button" @click="action ? redirectPage() : $emit('close')"
                class="btn btn-success button-coupon-text t16 fw600">{{action ? action.name : $t('close')}}
        </button>
    </div>
</template>

<script>
    import { mapActions } from 'vuex'
    import * as action from '../../store/actions'

    export default {
        props: {
            title: {type: String, default: ''},
            message: {type: String, default: ''},
            name: {type: String, default: ''},
            action: {type: [Object, Boolean], default: false},
        },
        data() {
            return {

            }
        },
        watch: {},
        mounted() {

        },
        methods: {
            ...mapActions({
                setDisposition: action.SET_DISPOSITION
            }),
            redirectPage() {
                this.$emit('close')
                this.$session.remove('cart')
                this.$session.remove('disposition')
                this.setDisposition({})
                this.redirectToPage(this.action.type)
            }
        }
    }
</script>

<style scoped>
    .close {
        margin-top: 0;
    }

    button {
        margin: auto;
        width: 100%;
        margin-top: 20px;
    }

    .modal-notify {
        max-width: 400px;
        margin: auto;
        background: white;
        padding: 15px;
    }

    .alert-danger2 {
        color: #a94442;
        font-weight: bold;
    }

    .free-menu-description {
        cursor: pointer;
    }

    .v--modal-box {
        height: auto !important;
        top: 50px !important;
    }

    .modal-coupon .v--modal {
        min-width: 0px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/popup/ModalNotify.vue